import { Button, TextLink } from '@vds/buttons';
import { Modal, ModalBody, ModalFooter, ModalTitle } from '@vds/modals';
import { Body } from '@vds/typography';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { isDesktop, isTab } from '../utils/globalConfig';
import { setModelTagging } from '../utils/tagging';
import CancelPendingOrderModal from './CancelPendingOrderModal';
import ErrorPage from "./ErrorPage";


const StyledSpace = styled.div`
margin-left:${isDesktop || isTab ? '20px' : ''};
margin-bottom:${isDesktop || isTab ? '' : '20px'};
`

const StyledTextLink = styled(TextLink)`
color:black
`


const StyledButtonDiv = styled.div`
display: flex;
`
const StyledPadding = styled.div`
padding-left: 24px;
`

const Space = styled.div`
padding-top: 24px;
`
const StyledFlex = styled.div`
display: flex;
gap: 5px;
`
const StyledInline = styled.div`
p {
display: inline;
}
`

const PendingOrderModal = ({ setPendingOrderModal ,pendingOrderObject,pendingOrderDeviceInfo}) => {

    const navigate = useNavigate();
    const [showCancelPendingOrderModal, setCancelPendingOrderModal] = useState(false);
    const [showModal, setShowModal] = useState(true);
    const [pendingOrderError, setPendingOrderError] = useState();

    const onOpenedChange = value => {
        setModelTagging('pendingOrderModal', 'pendingOrderModal', value);
        if (!value) {
            if (pendingOrderError)
                navigate(-2, { replace: true })
            else
                navigate(-1, { replace: true })

            setPendingOrderModal(false)
        }
    };
    const openNoThankyouLink = () => {
        setShowModal(false)
    }
    const openCancelPendingOrderBtn = () => {
        setCancelPendingOrderModal(true);

    }

    const learnMoreNavigation = (url) => {
       window.open(url, '_blank');
    }
    const showErrorModal = (error) => {
        setPendingOrderError(error)
    }
    return (
        <>
            <Modal
                opened={showModal}
                onOpenedChange={onOpenedChange}
                ariaLabel="pendingOrderModal"
                id = "pendingOrderModal"
            >
                 {pendingOrderError ? <ErrorPage errorDetails={pendingOrderError?.data} />:
                 <>
                 <ModalTitle bold size="large">{pendingOrderObject?.title}</ModalTitle>
                <ModalBody>   
                    <Space />
                    <StyledInline>
                    <Body size="large" >{pendingOrderObject?.message}</Body>
                    &nbsp;<StyledTextLink onClick={() => learnMoreNavigation(pendingOrderObject?.learnMoreUrl)}>{pendingOrderObject.learnMoreLabel}</StyledTextLink>
                    </StyledInline>
                    
                    <Space />
                    <>
                        <StyledFlex>
                            <Body bold={true}>{pendingOrderObject?.orderNumberLabel}</Body>
                            <Body>{pendingOrderDeviceInfo?.pendingOrderNumber}</Body>
                        </StyledFlex>
                        <StyledFlex>
                            <Body bold={true}>{pendingOrderObject?.dateSubmittedLabel}</Body>
                            <Body>{pendingOrderDeviceInfo?.effectiveDate}</Body>
                        </StyledFlex>
                        {pendingOrderDeviceInfo?.spoDescription && <StyledFlex>
                            <Body bold={true}>{pendingOrderObject?.descriptionLabel}</Body>
                            <Body>{pendingOrderDeviceInfo?.spoDescription}</Body>
                        </StyledFlex>}
                    </>
                </ModalBody>
                        <ModalFooter>
                            <StyledButtonDiv>
                                <TextLink onClick={() => openCancelPendingOrderBtn()} size="medium">{pendingOrderObject?.ctaList[1]?.ctaLabel}</TextLink>
                                <StyledSpace></StyledSpace>
                                <StyledPadding><Button onClick={() => openNoThankyouLink()} size="medium">{pendingOrderObject?.ctaList[0]?.ctaLabel}</Button></StyledPadding>
                                <StyledSpace></StyledSpace>

                            </StyledButtonDiv>
                        </ModalFooter>
                </>}
            </Modal>
            {showCancelPendingOrderModal &&
                <CancelPendingOrderModal
                    setCancelPendingOrderModal={setCancelPendingOrderModal}
                    cancelPendingOrderObj={pendingOrderObject?.cancelPendingOrder}
                    showErrorModal ={showErrorModal}
                    pendingOrderDeviceInfo={pendingOrderDeviceInfo}
                />
            }
            
        </>

    );
}

export default PendingOrderModal;